export default {
  setReq(state, payload) {
    state.reqID = payload.reqID;
    state.scopeID = payload.scopeID;
    state.storedValues = payload.storedValues;
  },
  clearGeoSatData(state) {
    state.reqID = null;
    state.scopeID = null;
    state.storedValues = null;
  },
};